import { GetState, SetState } from "zustand";
import { curry } from "../../utils/curry";
import { UseUserStore } from "./models";

export const userIsAdmin = curry((set:SetState<UseUserStore>, get:GetState<UseUserStore>, clubId:number) => async () => {
  const clubUser = get().clubUser 
  const club = get().club 
  return clubUser.clubId === clubId && club.id === clubId && (clubUser?.isCreator === 1 || clubUser?.isMediator === 1)
})

export const userIsMediator = curry((set:SetState<UseUserStore>, get:GetState<UseUserStore>, clubId:number)  => async () => {
  const clubUser = get().clubUser 
  const club = get().club 
  return clubUser.clubId === clubId && club.id === clubId && clubUser?.isMediator === 1
})